import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = "حساب كتلة الحديد - احسب كتلة الحديد";
const DESCRIPTION =
    "حاسبة كتلة الحديد الدقيقة: احسب وزن القطع الحديدية (بالكيلوجرام أو الطن) من خلال الأبعاد (طول، عرض، ارتفاع) أو الحجم! مثالية للمهندسين، المصنّعين، ومواد البناء - مع مراعاة كثافة الحديد القياسية.";
const KEYWORDS = "كتلة الحديد, حساب كتلة الحديد, حاسبة كتلة الحديد";
const OG_URL = "https://do-calculate.com/calculator/ar/iron-mass/";
function Calculator() {
    const [density, setDensity] = useState(7.8);
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [volume, setVolume] = useState('');
    const [ironMass, setIronMass] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!length || !width || !height) {
            setError('الرجاء إدخال الأبعاد بشكل صحيح');
            setVolume('');
            setIronMass('');
            return;
        }
        const lengthValue = parseFloat(length);
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);
        if (isNaN(lengthValue) || isNaN(widthValue) || isNaN(heightValue) || lengthValue <= 0 || widthValue <= 0 || heightValue <= 0) {
            setError('الرجاء إدخال قيم صحيحة وموجبة للأبعاد');
            setVolume('');
            setIronMass('');
            return;
        }
        const ironVolume = lengthValue * widthValue * heightValue;
        setVolume(ironVolume.toFixed(2));
        const mass = ironVolume * density;
        setIronMass(mass.toFixed(2));
        setError('');
    };
    return (
        <div className="rtl">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                    <div className="border border-light">
                        <div className="row">
                            <div>
                                <h2 style={{ fontSize: '18px' }}>كيفية حساب كتلة الحديد</h2>
                                <p>
                                    تستخدم حاسبة كتلة الحديد صيغة لحساب وزن الحديد، والتي تعتمد على المعادلة التالية:
                                </p>
                                <p>
                                    الوزن = الكثافة × الحجم
                                </p>
                                <p>
                                    في هذه الصيغة، الوزن هو الكمية المطلوبة من الحديد (بالجرام)، والكثافة المعتادة للحديد هي 7.8 جرام/سم³.
                                </p>
                                <p>
                                    لإجراء الحساب، يتعين عليك إدخال أبعاد قطعة الحديد (الطول والعرض والارتفاع) لتحديد الحجم. بعد ذلك، ستقوم الحاسبة بحساب الوزن بناءً على الكثافة والحجم.
                                </p>
                                <hr />
                            </div>
                        </div>
                        <MobileUnderCalAds />
                        <div className="row">
                            <div className="col-sm-12 col-md-7 calculatorStyle">
                                <div className='p-3 mb-2 bg-success text-white'>
                                    <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                </div>
                                <hr />
                                <div dir="rtl">
                                    <div>
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">الطول (سم)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="الطول"
                                                value={length}
                                                onChange={(e) => setLength(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">العرض (سم)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="العرض"
                                                value={width}
                                                onChange={(e) => setWidth(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <div className="form-group d-flex align-items-center">
                                            <b>
                                                <label className="form-label ms-2">الارتفاع (سم)</label>
                                            </b>
                                            <input
                                                type="number"
                                                placeholder="الارتفاع"
                                                value={height}
                                                onChange={(e) => setHeight(e.target.value)}
                                                className="form-control"
                                                style={{ width: '150px' }}
                                            />
                                        </div>
                                        <br />
                                        <button
                                            className="btn btn-success"
                                            style={{ fontSize: '20px' }}
                                            onClick={handleCalculate}
                                        >
                                            احسب كتلة الحديد
                                        </button>
                                    </div>
                                    <br />
                                    <div>
                                        {error !== '' ? (
                                            <p className='p-3 mb-2 bg-warning text-white'>خطأ: {error}</p>
                                        ) : (
                                            <>
                                                {ironMass !== '' && (
                                                    <p className='p-3 mb-2 bg-success text-white'>
                                                        كتلة الحديد: {ironMass} جم
                                                    </p>
                                                )}
                                                {volume !== '' && (
                                                    <p className='p-3 mb-2 bg-success text-white'>
                                                        حجم الحديد: {volume} سم³
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div className="row">
                            <RelatedLinks />
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="col">
                    <SecondAds />
                    <br />
                    <MainCalculatorsList />
                    <br />
                </div>
            </div>
            <div className="col-12 col-md-8">
                <div className="info-sections-container">
                    <div className="info-section">
                        <div className="info-section-header">
                            <h2 style={{ fontSize: "18px" }}>{TITLE}</h2>
                        </div>
                        <div className="info-section-body">
                            <p>{DESCRIPTION}</p>
                            <div>
                                <h3 style={{ fontSize: '16px' }}>كيفية حساب كتلة الحديد</h3>
                                <p>تستند حاسبة كتلة الحديد إلى الصيغة التالية لحساب الكتلة:</p>
                                <p><strong>الكتلة = الكثافة × الحجم</strong></p>
                                <p>في هذه الصيغة، الكتلة هي وزن قطعة الحديد (بالتقريب بالجرامات)، وتبلغ كثافة الحديد عادةً 7.8 غم/سم³.</p>
                                <p>لحساب الكتلة بدقة، يجب إدخال الأبعاد الثلاثة (الطول والعرض والارتفاع) للقطعة. ستقوم الحاسبة بحساب الحجم بناءً على هذه الأبعاد، ثم تستخدم الكثافة لحساب الوزن الكلي.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>كيفية استخدام حاسبة كتلة الحديد</h3>
                                <p>لاستخدام حاسبة كتلة الحديد بفعالية، أدخل القيم الدقيقة للطول والعرض والارتفاع في الحقول المخصصة. بعد إدخال هذه القيم، ستقوم الحاسبة بحساب الحجم أولاً باستخدام الصيغة:</p>
                                <p><strong>الحجم = الطول × العرض × الارتفاع</strong></p>
                                <p>ثم تستخدم الكثافة القياسية للحديد (7.8 غم/سم³) لتحديد الكتلة النهائية.</p>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>مثال على حساب كتلة الحديد</h3>
                                <p>افترض أن لديك قطعة حديد بأبعاد:</p>
                                <div className='p-3 mb-2 bg-info'>
                                    <strong>الطول:</strong> 12 سم <br />
                                    <strong>العرض:</strong> 4 سم <br />
                                    <strong>الارتفاع:</strong> 3 سم
                                </div>
                                <p>لحساب الحجم، نطبق الصيغة:</p>
                                <p><strong>الحجم = الطول × العرض × الارتفاع = 12 سم × 4 سم × 3 سم = 144 سم³</strong></p>
                                <p>لحساب الكتلة باستخدام الكثافة، نطبق الصيغة التالية:</p>
                                <p><strong>الكتلة = الكثافة × الحجم = 7.8 غم/سم³ × 144 سم³ = 1123.2 غم</strong></p>
                                <div className='p-3 mb-2 bg-info text-black'>
                                    لذا، الكتلة النهائية للقطعة هي 1123.2 غم.
                                </div>
                            </div>
                            <hr />
                            <div>
                                <h3 style={{ fontSize: '16px' }}>نصائح حول حساب كتلة الحديد</h3>
                                <p>لضمان حساب دقيق، تأكد من إدخال الأبعاد بدقة. كما ينبغي استخدام كثافة الحديد المناسبة لنوع الحديد الذي تستخدمه. لمزيد من المعلومات حول خصائص الحديد وكثافته، يمكنك الرجوع إلى المصادر التالية:</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Calculator;
